module.exports = __webpack_public_path__ + "static/media/female-condom-green.77ea56f1.svg";